import HeadingTexts from '../../common/HeadingTexts'
import gallery1 from '../../../Assets/Gallery/IMG-20251105-WA0002.jpg'
import gallery2 from '../../../Assets/Gallery/IMG-20251105-WA0003.jpg'
import gallery3 from '../../../Assets/Gallery/IMG-20251105-WA0004.jpg'
import gallery4 from '../../../Assets/Gallery/IMG-20251105-WA0005.jpg'
import gallery5 from '../../../Assets/Gallery/IMG-20251105-WA0006.jpg'
import gallery6 from '../../../Assets/Gallery/IMG-20251105-WA0007.jpg'
import gallery7 from '../../../Assets/Gallery/IMG-20251105-WA0008.jpg'
import gallery8 from '../../../Assets/Gallery/IMG-20251105-WA0009.jpg'
import gallery9 from '../../../Assets/Gallery/IMG-20251105-WA0010.jpg'
import gallery10 from '../../../Assets/Gallery/IMG-20251105-WA0011.jpg'
import gallery12 from '../../../Assets/Gallery/IMG-20251105-WA0012.jpg'
import gallery13 from '../../../Assets/Gallery/IMG-20251105-WA0013.jpg'
import gallery14 from '../../../Assets/Gallery/IMG-20251105-WA0014.jpg'
import gallery15 from '../../../Assets/Gallery/IMG-20251105-WA0015.jpg'
import gallery16 from '../../../Assets/Gallery/IMG-20251105-WA0016.jpg'
import gallery17 from '../../../Assets/Gallery/gallery1.avif'
import gallery18 from '../../../Assets/Gallery/gallery2.jpg'
import gallery19 from '../../../Assets/Gallery/gallery3.avif'
import gallery20 from '../../../Assets/Gallery/gallery4.jpg'
import gallery21 from '../../../Assets/Gallery/gallery5.avif'
import gallery22 from '../../../Assets/Gallery/gallery6.avif'
import gallery23 from '../../../Assets/Gallery/gallery7.avif'
import gallery24 from '../../../Assets/Gallery/gallery8.avif'
import gallery25 from '../../../Assets/Gallery/gallery9.avif'
import gallery26 from '../../../Assets/Gallery/gallery10.avif'

const galleryImg = [
  gallery1, gallery4, gallery5, gallery6, gallery3, gallery7, gallery8, gallery9, gallery10, gallery12, gallery13, gallery14, gallery15, gallery16, gallery2,gallery17,gallery18,gallery19,gallery20,gallery21,gallery22,gallery23,gallery24,gallery25,gallery26,
]

const GalleryHero = () => {
  return (
    <section className='py-10'>
      <HeadingTexts label={'OUR GALLERY'} text={'Explore Our Stunning Moments captured'} bluetext={'  in every frame.'} position={'center'} />
      <div className='xl:columns-4 md:columns-3 columns-2 space-y-10 px-6 md:px-16 my-10'>
        {
          galleryImg.map((img, index) => (
            <figure key={index} data-aos={"zoom-in"} data-aos-duration="700" className='rounded-lg w-[90%] shadow-lg overflow-hidden'><img className='object-cover w-full' src={img} alt="gallery-image" /></figure>
          ))
        }
      </div>
    </section>
  )
}

export default GalleryHero